import { transformValues as baseTransformValues } from './transformValues';

export function transformFields(response, addressFieldMap) {
  if (
    !response ||
    !response.Items ||
    !response.Items.length ||
    response.Items[0].Error
  ) {
    return false;
  }
  return Object.keys(addressFieldMap).reduce((data, fieldName) => {
    const locateFieldNames =
      typeof addressFieldMap[fieldName] === 'string'
        ? [addressFieldMap[fieldName]]
        : addressFieldMap[fieldName];

    if (!locateFieldNames) {
      data[fieldName] = undefined;
      return data;
    }

    let nextSeparator = '';

    data[fieldName] = locateFieldNames.reduce(
      (concatenatedValue, locateFieldName) => {
        // Look for a separator config between address text, separator starts with { and ends with }
        // Example: {/} between apartment name and apartment number should look like apartment name/apartment number
        const separatorMatch = locateFieldName.match(/^\{(.*)\}$/);

        if (separatorMatch) {
          nextSeparator = separatorMatch[1];
          return concatenatedValue;
        }

        const value = response.Items[0][locateFieldName];
        const separator = concatenatedValue ? nextSeparator : '';

        const newConcatenatedValue = value
          ? `${concatenatedValue}${separator}${value}`
          : concatenatedValue;

        nextSeparator = '';
        return newConcatenatedValue;
      },
      ''
    );
    return data;
  }, {});
}

export function transformValues(data, addressValueMap) {
  return baseTransformValues(data, addressValueMap, true);
}

export function transformOptions(response) {
  if (
    !response ||
    !response.Items ||
    !response.Items.length ||
    response.Items[0].Error
  ) {
    return false;
  }

  const options = [];

  for (let i = 0; i < response.Items.length; i++) {
    // Ugly hack for Loqate until the issue is fixed by Loqate Support
    if (!/(Prague|Prag|Praga|Pilsen)$/.test(response.Items[i].Text)) {
      options.push({
        id: response.Items[i].Id,
        label: response.Items[i].Text,
        subLabel: response.Items[i].Description,
        isCapturable: response.Items[i].Type === 'Address'
      });
    }
  }
  return options;
}
